import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Context as ReviewsContext } from "../../context/ReviewsContext";
import CategoryStat from "./CategoryStat";
import { Button, ButtonGroup } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  statsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "wrap",
    paddingTop: 2,
    paddingBottom: 4,
    paddingLeft: 3,
    paddingRight: 3,
    margin: 3,
    marginBottom: 8,
    borderRadius: 5,
  },
}));

const Indicators = () => {
  const classes = useStyles();
  const {
    state: { daily, monthly, historic, validScopes },
    fetchIndicators,
  } = useContext(ReviewsContext);

  const [scope, setScope] = useState(validScopes[0]);
  const [indicator, setIndicator] = useState({...daily});

  useEffect(() => {
    if (Object.keys(daily).length === 0){
        fetchIndicators();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIndicator(daily);
    // eslint-disable-next-line
  }, [daily]);

  const handleScopeChange = (sp) => {
    setScope(sp);
    switch (sp) {
      case "dia":
        setIndicator(daily);
        break;
      case "mes":
        setIndicator(monthly);
        break;
      default:
        setIndicator(historic);
        break;
    }
  };

  const buttonGroup = validScopes.map((sp, index) => (
    <Button
      key={index}
      disabled={sp === scope}
      onClick={() => handleScopeChange(sp)}
    >
      {sp}
    </Button>
  ));

  return (
    <div>
      <ButtonGroup
        variant="contained"
        color="primary"
        aria-label="contained primary button group"
      >
        {buttonGroup}
      </ButtonGroup>
      <div className={classes.statsContainer}>
        <CategoryStat title={"Servicio"} score={indicator.service} />
        <CategoryStat title={"Calidad"} score={indicator.quality} />
        <CategoryStat title={"Limpieza"} score={indicator.cleanliness} />
      </div>
    </div>
  );
};
export default Indicators;
